//////////////////////////////////////
import { axiosDefault } from '@/core/utils';
import { ClaimGiftMapper } from '@/core/mappers';

const claimGift = async () => {
	const url = `/tg/user/collection/claim/sticker`;
	const response = await axiosDefault.get(url);
	return ClaimGiftMapper(response.data);
};

const hideOnboardingCollections = async () => {
	const url = `/tg/user/collection/tutorial`;
	return await axiosDefault.put(url);
};

const claimCollectionReward = async (collectionId: string) => {
	const url = `/tg/user/collection/${collectionId}/diamonds/claim`;
	const response = await axiosDefault.get(url);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		newDiamonds: response.data.newDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
	};
};

export const CollectionsService = {
	claimGift,
	hideOnboardingCollections,
	claimCollectionReward,
};
